import { APP_RATING_MIN_THRESHOLD } from '../app/constants/constants';

export const hasPositiveLatestSession = (
  sessions?: Array<{
    sessionID?: string | null;
    rating?: number | string | null;
  }> | null
): boolean => {
  if (!sessions || sessions.length === 0) {
    return false;
  }

  const latestSession = sessions[0];
  const numericRating = Number(latestSession?.rating);

  if (Number.isNaN(numericRating)) {
    return false;
  }

  return numericRating >= APP_RATING_MIN_THRESHOLD;
};
